import { useMassActionsContext } from '@components/MassActions/contexts/MassActions.context';
import useSearchParams from '../../../../../hooks/useSearchParams';
import LangEnum from '../../../../../lang/LangEnum';
import snackbarStore from '../../../../../stores/Snackbar.store';
import { UsedInOfflineMode } from '../../../../offline/types/UsedInOfflineMode';
import { useTranslation } from '../../../../translation/TranslationContext';
import { OrderListTabName } from '../../../list/orderListTabs';
import { exportOrdersCsvWithOffline } from '../utils/exportOrdersCsvWithOffline';

interface UseExportMultipleOrdersCsvProps extends UsedInOfflineMode {
  selectedIds?: string[];
  selectedTab: OrderListTabName;
  customerIds?: string[];
}

const useExportMultipleOrdersCsv = ({
  selectedIds,
  selectedTab,
  customerIds,
}: UseExportMultipleOrdersCsvProps) => {
  const { handleMessage } = snackbarStore;
  const { translate } = useTranslation();
  const { searchParams } = useSearchParams();
  const { filterMaxResults } = useMassActionsContext();
  const { ids, ...restSearchParams } = searchParams;

  const handleExportCsvs = async () => {
    const paramsToExport = {
      searchParams: {
        ...(selectedIds ? { ids: selectedIds } : {}),
        ...restSearchParams,
        ...(customerIds ? { customerIds } : {}),
      },
      translate,
    };

    const response = await exportOrdersCsvWithOffline({
      paramsToExport,
      selectedIds,
      filterMaxResults,
      selectedTab,
    });

    if (response && !response.ok && response.status === 400) {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.ORDER_EXPORT_CSV_ERROR_MESSAGE),
      });
    }
  };

  return { handleExportCsvs };
};

export default useExportMultipleOrdersCsv;
